<table mat-table [dataSource]="dataSource" matSort style="width: 100%;" matSortActive="year" matSortDirection="desc">

  <!-- value Column -->
  <ng-container matColumnDef="value">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.value' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.value | number :'0.4' :'fr' }}</span>
    </td>
  </ng-container>

  <!-- year Column -->
  <ng-container matColumnDef="year">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.year' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.year }}</span>
    </td>
  </ng-container>

  <!-- coef Column -->
  <ng-container matColumnDef="coef">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.index-coef' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.coef | number :'0.4' :'fr' }}</span>
    </td>
  </ng-container>

  <!-- modifiedDate Column -->
  <ng-container matColumnDef="modifiedDate">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.modifiedDate' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.modifiedDate | date : 'dd/MM/yy'}}</span>
    </td>
  </ng-container>

  <!-- userName Column -->
  <ng-container matColumnDef="userName">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.user' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.userName }}</span>
    </td>
  </ng-container>

  <!-- action Column -->
  <ng-container matColumnDef="action">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header> </div>
    </th>
    <td mat-cell *matCellDef="let element">
      <button mat-raised-button color="primary" (click)="editElement(element)" style="margin-right: 10px;">
        <mat-icon>edit</mat-icon>
        {{ 'button.edit' | translate }}
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'highlight': selectedRowID == row.id}"
    (click)="selectItemClick(row)"></tr>
</table>
<mat-paginator #MatPaginatorIndex class="m-5 mat-elevation-z2" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons>
</mat-paginator>